export interface DisplayableError {
  code?: unknown;
  statusCode?: unknown;
  message?: unknown;
  digest?: unknown;
}

export interface ErrorDisplay {
  kind: 'code' | 'message';
  text: string;
}

function normalizeErrorCode(code: unknown): string | undefined {
  if (typeof code === 'number') {
    return Number.isFinite(code) && code !== 0 ? String(code) : undefined;
  }

  if (typeof code !== 'string') return undefined;

  const normalizedCode = code.trim();
  return normalizedCode && normalizedCode !== '0' ? normalizedCode : undefined;
}

/**
 * 错误页优先展示具体错误码；没有有效错误码时保持原有的 500 兜底。
 */
export function getErrorDisplay(error: DisplayableError): ErrorDisplay {
  const errorCode = normalizeErrorCode(error.code) ?? normalizeErrorCode(error.statusCode);
  if (errorCode) return { kind: 'code', text: errorCode };

  return { kind: 'code', text: '500' };
}
